import { render } from "./SingleClub.vue?vue&type=template&id=29908fc1"
import script from "./SingleClub.vue?vue&type=script&lang=js"
export * from "./SingleClub.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__